import React from "react";
import { RouteObject } from "react-router";

import { Lazy } from "@shared/components/ui/lazy";

const Admin = Lazy(() => import("@shared/features/admin/pages/admin"), "Admin");
const AdminAppointments = Lazy(() => import("@shared/features/admin/pages/admin-appointments"), "AdminAppointments");
const AdminAppointmentsList = Lazy(() => import("@shared/features/admin/pages/admin-appointments-list"), "AdminAppointmentsList");
const AdminPendingDoctors = Lazy(() => import("@shared/features/admin/pages/admin-pending-doctors"), "AdminPendingDoctors");
const AdminPendingOrganizations = Lazy(() => import("@shared/features/admin/pages/admin-pending-organizations"), "AdminPendingOrganizations");
const AdminProductCreate = Lazy(() => import("@shared/features/admin/pages/admin-product-create"), "AdminProductCreate");
const AdminProductEdit = Lazy(() => import("@shared/features/admin/pages/admin-product-edit"), "AdminProductEdit");
const AdminProducts = Lazy(() => import("@shared/features/admin/pages/admin-product"), "AdminProducts");
const AdminSettings = Lazy(() => import("@shared/features/admin/pages/admin-profile"), "AdminSettings");
const AdminSupplyRequestDetail = Lazy(() => import("@shared/features/admin/pages/admin-supply-request-detail"), "AdminSupplyRequestDetail");
const AdminSupplyRequests = Lazy(() => import("@shared/features/admin/pages/admin-supply-requests"), "AdminSupplyRequests");
const AdminUsers = Lazy(() => import("@shared/features/admin/pages/admin-users"), "AdminUsers");
const AdminFeedbackDetails = Lazy(() => import("@shared/features/feedback/pages/admin-feedback-details"), "AdminFeedbackDetails");
const AdminFeedbackList = Lazy(() => import("@shared/features/feedback/pages/admin-feedback-list"), "AdminFeedbackList");
const ResultCheckup = Lazy(() => import("@shared/features/patient-check-up/result-checkup"), "ResultCheckup");
const ResultCheckupForm = Lazy(() => import("@shared/features/patient-check-up/result-checkup-form"), "ResultCheckupForm");
const AdminSubscriptions = Lazy(() => import("@shared/features/admin/pages/admin-subscriptions"), "AdminSubscriptions");

export const getAdminRoutes = (): RouteObject[] => {
  return [
    { index: true, element: <Admin /> },
    {
      path: "patient-check-result",
      children: [
        { index: true, element: <ResultCheckup /> },
        { path: ":id", element: <ResultCheckupForm /> },
      ],
    },
    { path: "pending-organizations", element: <AdminPendingOrganizations /> },
    { path: "pending-doctors", element: <AdminPendingDoctors /> },
    {
      path: "feedbacks",
      children: [
        { index: true, element: <AdminFeedbackList /> },
        { path: ":id", element: <AdminFeedbackDetails /> },
      ],
    },
    { path: "users", element: <AdminUsers /> },
    { path: "products", element: <AdminProducts /> },
    { path: "products/new", element: <AdminProductCreate /> },
    { path: "products/edit/:id", element: <AdminProductEdit /> },
    { path: "supply-requests", element: <AdminSupplyRequests /> },
    { path: "supply-requests/:id", element: <AdminSupplyRequestDetail /> },
    {
      path: "appointments",
      children: [
        { index: true, element: <AdminAppointments /> },
        { path: "list", element: <AdminAppointmentsList /> },
      ],
    },
    {
      path: "subscriptions",
      element: <AdminSubscriptions />,
    },
    { path: "user/settings", element: <AdminSettings /> },
  ];
};
